module.exports = __webpack_public_path__ + "img/galeria-forrageiras-4.9c5f66c3.jpg";